import React, { useEffect } from 'react';
import FederatedLayout from '../../layout/federatedLayout';
import images from '../../assets/images';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Common } from '../../utils/constants';

const MigrationSuccess: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const message: string = sessionStorage.getItem(Common.FederatedAccountMigrationSessionKeys.MIGRATION_SUCCESS) || '';

  useEffect(() => {
    for (const key in sessionStorage) {
      if (key.startsWith(Common.FederatedAccountMigrationSessionKeys.MIGRATION_OTP_VERIFIED)) {
        sessionStorage.removeItem(key);
      }
    }
    navigate('.', { replace: true });
  }, [navigate]);

  return (
    <FederatedLayout>
      <div className="p-4 text-center d-flex flex-column justify-content-center align-items-center migration-success-container">
        <div className="title-outer">
          <h1 className="title migration-success-icon">
            <span className="icon">
              <img src={images.SuccessSVG} alt="success" />
            </span>
          </h1>
        </div>
        <h1 className="text-success migration-success-title">{t('Payment.PaymentSuccess.label')}</h1>
        {message && <p className="mt-3 migration-success-message">{message}</p>}
      </div>
    </FederatedLayout>
  );
};

export default MigrationSuccess;
